import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container",
  id: "errorToast"
}
const _hoisted_2 = { class: "message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(`content ${$props.variant}`)
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString($setup.errorMessage), 1),
      _createElementVNode("button", {
        class: "button times",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clearToast && $setup.clearToast(...args)))
      }, [
        _createVNode(_component_font_awesome_icon, {
          class: _normalizeClass(`close-toast ${$props.variant}`),
          icon: ['fas', 'times']
        }, null, 8, ["class"])
      ])
    ], 2)
  ]))
}